export const SITE_URL = 'https://www.psihoterapija-verbnik.si';
export const SITE_NAME = 'Psihoterapija Špela Verbnik';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/photo_scaled_x_y.jpg`;

export const PRACTICE = {
  name: SITE_NAME,
  personName: 'Špela Verbnik',
  jobTitle: 'Psihoterapevtka in psihologinja',
  email: 'spela.verbnik@gmail.com',
  telephone: '+38641590888',
  telephoneDisplay: '041 590 888',
  streetAddress: 'Celovška cesta 73',
  postalCode: '1000',
  addressLocality: 'Ljubljana',
  addressCountry: 'SI',
  sameAs: [
    'https://hipnoza-dmhs.si/user/spela.verbnik/',
    'https://www.drustvo-dsps.si/specializanti/',
  ],
};

export function absoluteUrl(path = '/') {
  if (!path.startsWith('/')) {
    return `${SITE_URL}/${path}`;
  }
  return `${SITE_URL}${path === '/' ? '/' : path}`;
}
